import {connect} from '../app/connect';
import BaseComponent from './BaseComponent';
import {isFFLoaded} from '../app/selectors';

const mapStateToProps = state => ({
  isFFLoaded: isFFLoaded(state)
});

export default connect(
  mapStateToProps,
  undefined,
  undefined,
  {forwardRef: true}
)(BaseComponent);
